import { render, staticRenderFns } from "./SurfacePostComment.vue?vue&type=template&id=3c31f982&scoped=true&"
import script from "./SurfacePostComment.vue?vue&type=script&lang=ts&"
export * from "./SurfacePostComment.vue?vue&type=script&lang=ts&"
import style0 from "./SurfacePostComment.vue?vue&type=style&index=0&id=3c31f982&prod&lang=postcss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3c31f982",
  null
  
)

export default component.exports